import SimSingleMultiQuestion from "../shared/SimSingleMultiQuestion";
import SimPuzzleQuestion from "../shared/SimPuzzleQuestion";
import SimManualQuestion from "../shared/SimManualQuestion";

function Page2({ sim, setSim, setQuestion }) {
    const q = sim.currentQuestions[sim.currentQuestion]

    return (
        <div className="exam-sim-page-3">
            {['single', 'multiple'].indexOf(q?.type) !== -1 && <SimSingleMultiQuestion sim={sim} setSim={setSim} setQuestion={setQuestion} question={q} />}
            {q?.type === 'manual' && <SimManualQuestion sim={sim} setSim={setSim} setQuestion={setQuestion} question={q} />}
            {q?.type === 'puzzle' && <SimPuzzleQuestion sim={sim} setSim={setSim} setQuestion={setQuestion} question={q} />}
        </div>
    );
}
export default Page2;
